export default __webpack_public_path__ + "static/media/websitev2.f3d72f56.png";